(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const nodes = [...document.querySelectorAll('[data-delivery-reveal]')];
  if (!nodes.length || !('IntersectionObserver' in window)) return;
  document.body.classList.add('js-ready');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px 8% 0px', threshold: 0.08 });
  nodes.forEach(node => observer.observe(node));
})();